import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CTASection from '../components/sections/CTASection';
import SocialProof from '../components/sections/SocialProof';

const whatWeDoItems = [
  'přípravy hodin',
  'pracovní materiály',
  'hodnocení',
  'komunikace s rodiči',
  'administrativní texty',
];

const benefitsItems = [
  'příprava výuky a aktivit',
  'tvorba pracovních listů a testů',
  'diferenciace podle úrovně žáků',
  'slovní hodnocení a zpětná vazba',
  'administrativní texty',
  'komunikace s rodiči',
];

export default function ProReditelePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>

        {/* Hero */}
        <section className="pt-36 pb-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="inline-flex items-center px-4 py-2 bg-teal-50 border border-teal-100 rounded-full text-teal-700 text-sm font-medium mb-8">
              Financovatelné z OP JAK II
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 leading-tight mb-8">
              AI už je součástí školy —<br />
              <span className="text-teal-600">a s ní i nové otázky.</span>
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed mb-6 max-w-2xl">
              Učitelé i žáci se s AI setkávají stále častěji. Vedle jejích přínosů se
              objevují i nové situace, na které školy musí reagovat.
            </p>
            <div className="border-l-4 border-teal-500 pl-6 py-2 my-8 max-w-2xl">
              <p className="text-xl font-medium text-slate-800 leading-relaxed">
                Největší rozdíl dnes není v tom, jestli škola AI řeší.
              </p>
              <p className="text-xl font-bold text-teal-700 mt-1">
                Rozdíl je v tom, jak ji řeší.
              </p>
            </div>
          </div>
        </section>

        {/* Jak to děláme */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-6">Jak probíhá školení</p>
            <p className="text-lg text-slate-600 leading-relaxed mb-6 max-w-2xl">
              Někde školení končí u prezentace nástrojů. U nás pedagogové pracují přímo
              na věcech, které ve škole skutečně dělají:
            </p>
            <div className="grid sm:grid-cols-2 gap-3 max-w-xl mb-10">
              {whatWeDoItems.map((item, i) => (
                <div key={i} className="flex items-center gap-3 bg-white rounded-lg px-4 py-3 border border-slate-200">
                  <div className="w-2 h-2 rounded-full bg-teal-500 flex-shrink-0" />
                  <span className="text-slate-700 font-medium">{item}</span>
                </div>
              ))}
            </div>

            <div className="max-w-2xl space-y-4">
              <p className="text-lg text-slate-600 leading-relaxed">
                Neodcházejí s pocitem, že <em>„něco slyšeli o AI"</em>.
              </p>
              <p className="text-lg font-semibold text-slate-900 leading-relaxed">
                Odcházejí s konkrétní zkušeností, jak ji použít při své práci.
              </p>
              <p className="text-teal-700 font-semibold text-lg">
                A to je rozdíl, který je ve škole vidět hned druhý den.
              </p>
            </div>
          </div>
        </section>

        {/* Co školení přinese */}
        <section className="py-16 bg-white border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-6">Co školení přinese škole</p>
            <p className="text-xl text-slate-700 font-medium mb-4 max-w-2xl">
              Pedagogové se naučí využívat AI v oblastech, které ve škole skutečně řeší.
            </p>
            <p className="text-base text-slate-500 mb-8">Například:</p>
            <div className="grid sm:grid-cols-2 gap-3 max-w-xl mb-10">
              {benefitsItems.map((item, i) => (
                <div key={i} className="flex items-center gap-3 bg-slate-50 rounded-lg px-4 py-3 border border-slate-200">
                  <div className="w-2 h-2 rounded-full bg-teal-500 flex-shrink-0" />
                  <span className="text-slate-700">{item}</span>
                </div>
              ))}
            </div>
            <p className="text-lg text-slate-700 max-w-2xl leading-relaxed">
              Škola tak získává tým pedagogů, který umí AI využívat{' '}
              <strong className="text-slate-900">efektivně a odpovědně</strong>.
            </p>
          </div>
        </section>

        <SocialProof />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
